module.exports = __webpack_public_path__ + "media/stylesheets/images/cancel_@2X-7d71f189f79502b653891a640a4c3121.png";